import type { FC } from 'react';
import React from 'react';
import { Flex } from '@edreamsodigeo/prisma-design-system';

import SectionDateTimeMapItinerary from '@/components/FlightSummary/MapItinerary/components/SectionDateTimeMapItinerary';
import SectionLocationMapItinerary from '@/components/FlightSummary/MapItinerary/components/SectionLocationMapItinerary';
import TripLine from '@/components/FlightSummary/MapItinerary/components/TripLine';
import type { Section } from '@/generated/graphql';
import LeftContentWrapper from './LeftContentWrapper';

interface SectionTripEventMapItineraryProps {
  location: Section['departure'];
  dateTime: string;
  type: string;
  terminal?: Section['arrivalTerminal'];
}

const SectionTripEventMapItinerary: FC<SectionTripEventMapItineraryProps> = ({
  location,
  dateTime,
  type,
  terminal,
}) => {
  return (
    <Flex>
      <LeftContentWrapper>
        <Flex flexDirection="column">
          <SectionDateTimeMapItinerary dateTime={dateTime} />
        </Flex>
      </LeftContentWrapper>
      <TripLine type={type} />
      <Flex flexDirection="column">
        <SectionLocationMapItinerary {...location} terminal={terminal} />
      </Flex>
    </Flex>
  );
};

export default SectionTripEventMapItinerary;
